import styled from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';

export const Groups = styled.div`
  gap: 10px;
  grid-template-columns: repeat(3, 1fr);
  display: grid;
`;

export const PushButton = styled.button`
  ${transition()};
  min-height: 240px;
  padding: 16px;
  
  font-weight: 500;
  font-size: 14px;
  color: ${({theme}) => `
    ${transparentize(.7, theme.variables.color)};
  `};
  
  display: grid;
  column-gap: 12px;
  align-items: center;
  grid-auto-flow: column;
  justify-content: center;
  
  border-radius: 5px;
  border: 1px dashed ${({theme}) => `
    ${theme.variables.borderColor};
  `};

  &:hover {
    color: ${({theme}) => `
      ${transparentize(.5, theme.variables.color)};
    `};
  }
`;
